<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import {formatDate, setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import DateControl from "../components/controls/DateControl.svelte";
    import TimeControl from "../components/controls/TimeControl.svelte";
    import VehicleControl from "../components/controls/VehicleControl.svelte";
    import DriverControl from "../components/controls/DriverControl.svelte";
    import ShiftIncomesComponent from "./ShiftIncomesComponent.svelte";
    import ShiftExpensesControl from "./ShiftExpensesControl.svelte";
    import ShiftServiceDay from "./ShiftServiceDay.svelte";
    import Notifier from "../stores/notifier";

    export let shiftId;
    export let closeCallback = null;

    let shift = null;
    let startDate = '';
    let startTime = '';
    let endDate = '';
    let endTime = '';
    let driver = null;
    let vehicle = null;
    let title = shiftId > 0 ? "Shift" : "New shift";
    let shiftEnded = false;


    const load = () => {
        const onSuccess = result => {
            shift = result;
            [startDate, startTime] = shift.start_at.split(' ');

            if (shift.end_at) {
                [endDate, endTime] = shift.end_at.split(' ');
                shiftEnded = true;
            }

            if (shift.driver) {
                driver = shift.driver;
            }
            if (shift.vehicle) {
                vehicle = shift.vehicle;
            }
            delete (shift.driver);
            delete (shift.vehicle);
        };

        const onFailure = err => {
        };

        if (shiftId == 0) {
            R.handle(R.shift.initialize, {}, onSuccess, onFailure, LOADER.POPUP);
        } else {
            R.handle(R.shift.details, shiftId, onSuccess, onFailure, LOADER.POPUP);
        }
    }

    const save = () => {
        const onSuccess = result => {
            shift.id = result.id;
            Notifier.showMessage("Shift saved");
            close(shift);
        };

        const onFailure = err => {
        };

        if (!driver) {
            Notifier.showError("Select a driver for the shift!");
            setFocusTo("shiftDriver");
            return;
        }

        if (!shift.vehicle_id || shift.vehicle_id == 0) {
            Notifier.showError("Select a vehicle for the shift!");
            setFocusTo("shiftVehicle");
            return;
        }

        if (!startTime) {
            Notifier.showError("Select a vehicle for the shift!");
            setFocusTo("startTime");
            return;
        }

        shift.start_klm = shift.start_klm == null ? null : ~~shift.start_klm;
        shift.end_klm = shift.end_klm == null ? null : ~~shift.end_klm;

        if (!shift.start_klm || shift.start_klm == 0) {
            Notifier.showError("Enter the Klm for the start of the shift!");
            setFocusTo("startKlm");
            return;
        }
        if (shift.end_klm > 0 && shift.end_klm < shift.start_klm) {
            Notifier.showError("Value of Klm for the end of the shift is not valid!");
            setFocusTo("endKlm");
            return;
        }

        shift.driver_id = driver ? driver.id : null;

        shift.start_at = `${startDate} ${startTime}`;
        if (endDate && endTime) {
            shift.end_at = `${endDate} ${endTime}`;
            shift.duration = new Date(shift.end_at) - new Date(shift.start_at);
        } else {
            shift.end_at = null;
            shift.duration = null;
        }

        shift.total_klm = (shift.start_klm && shift.end_klm) ? shift.end_klm - shift.start_klm : null;

        if (shift.id == 0) {
            R.handle(R.shift.create, shift, onSuccess, onFailure, LOADER.POPUP);
        } else {
            R.handle(R.shift.edit, shift, onSuccess, onFailure, LOADER.POPUP);
        }
    }


    const endShift = () => {
        let now = new Date();
        endDate = formatDate(now, 'y-m-d');
        endTime = formatDate(now, 'H:i');
        shiftEnded = true;
    }


    const close = (param) => {
        shift = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    load();
</script>

{#if shift}
    <Modal modalSm {title} on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class="col-md-6 col-12 form-group">
                    <label>Driver</label>
                    <DriverControl id="shiftDriver" bind:driver={driver} placeholder="select driver" disabled={!user.isGod}/>
                </div>
                <div class="col-md-6 col-12 form-group">
                    <label>Vehicle</label>
                    <VehicleControl id="shiftVehicle" bind:vehicle_id={shift.vehicle_id} placeholder="select vehicle"/>
                </div>
            </div>

            <div class="legend mb-2">Shift Start</div>
            <div class="row">
                <div class="col-md-5 col-6">
                    <label>Date</label>
                    <DateControl bind:value={startDate} hideClear/>
                </div>
                <div class="col-md-3 col-6 form-group">
                    <label>Time</label>
                    <TimeControl id="startTime" bind:time={startTime}/>
                </div>
                <div class="col-md-4 col-12 form-group">
                    <label>Klm</label>
                    <input type="number" class="form-control" id="startKlm" bind:value={shift.start_klm}>
                </div>
            </div>

            {#if !shiftEnded}
                <button class="btn btn-block btn-primary mb-4" on:click={endShift}>END</button>
            {/if}

            {#if shiftEnded}
                <div class="legend mb-2">Shift End</div>
                <div class="row">
                    <div class="col-md-5 col-6">
                        <label>Date</label>
                        <DateControl bind:value={endDate}/>
                    </div>
                    <div class="col-md-3 col-6 form-group">
                        <label>Time</label>
                        <TimeControl bind:time={endTime}/>
                    </div>
                    <div class="col-md-4 col-12 form-group">
                        <label>Klm</label>
                        <input type="number" class="form-control" id="endKlm" bind:value={shift.end_klm}>
                    </div>
                </div>
            {/if}

            <div class="mb-4">
                <ShiftExpensesControl bind:shift={shift}/>
            </div>

            <div class="mb-4">
                <ShiftIncomesComponent bind:shift={shift}/>
            </div>

            <ShiftServiceDay bind:shift={shift}/>

            <hr>
            <div class="text-end">
                <button class="btn btn-link me-2" on:click="{ () => close() }">Close</button>
                <button class="btn btn-primary px-4" on:click={save}>Save</button>
            </div>
        </div>
    </Modal>
{/if}

<style>
    :global(.totals th) {
        font-weight: normal;
        line-height: 1;
        color: #6b6b6b;
        vertical-align: bottom;
        padding: 7px 5px 7px 0;
    }

    :global(.totals td) {
        vertical-align: middle;
        border: unset;
        padding: 0;

    }

    :global(.small-input) {
        border-color: #e9e9e9;
        padding: 0 5px;
    }

    :global(.no-input) {
        text-align: center;
        border: 1px solid #e9e9e9 !important;
    }
</style>